import { Component, OnInit, ViewChild, inject, signal, ViewEncapsulation } from "@angular/core";

import { BlogService } from "../services/blog.service";
import { Blog } from "../models/blog";
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule } from "@angular/forms";
import {
  PAGES_COMPANY,
  PAGES_ROOM,
  SETTINGS,
  TYPE_LIST,
} from "../constants/constants";
import { CategoryService } from "src/app/services/categories.service";
import { Category } from "src/app/models/category";
import { Router, ActivatedRoute, RouterLink } from "@angular/router";
import { MessageService } from "primeng/api";
import { ClientsService } from "src/app/services/clients.service";
import { Clients } from "src/app/models/clients";
import { ComuniService } from "src/app/services/comuni.service";
import { Comuni } from "src/app/models/comuni";
import { Bookings } from "src/app/models/bookings";
import { BookingsService } from "src/app/services/bookings.service";
import * as $ from "jquery";
import { PAGES } from "../constants/constants";
import { Bind } from "primeng/bind";
import { InputText } from "primeng/inputtext";

import { Card } from "primeng/card";
import { LabelPipe } from "../pipe/label.pipe";

import { TPipe } from "../i18n/t.pipe";
@Component({
    standalone: true,
    selector: "app-settings",
    templateUrl: "./settings.component.html",
    styleUrl: "./settings.component.less",
    encapsulation: ViewEncapsulation.None,
    imports: [TPipe, FormsModule, Bind, InputText, Card, RouterLink, LabelPipe]
})
export class SettingsComponent implements OnInit {
  private blogService = inject(BlogService);
  private clientsService = inject(ClientsService);
  private bookingsService = inject(BookingsService);
  private fb = inject(UntypedFormBuilder);
  private comuniService = inject(ComuniService);
  private categoryService = inject(CategoryService);
  private router = inject(Router);
  private messageService = inject(MessageService);
  private route = inject(ActivatedRoute);

  query: string;
  filter = {
    label: "",
  };
  calendarOptions: any;
  events: any;
  bookings: Bookings;
  error: string;
  blogForm: UntypedFormGroup;
  typeList: any;
  settingsPages: any;
  cities: Blog[];
  format1: string = "";
  format2: string = "";
  selectedCity: Blog;
  uploadError: string;
  selectedCategories: Category;
  selectedDate: Date;
  date: Date;
  categories: any = [];
  category: Category;
  roomDialog: boolean = false;
  bookingsDialog: boolean = false;
  clients: any = [];
  client: Clients;
  comuni: any = [];
  readonly items = signal<any>([]);
  readonly itemsRoom = signal<any>([]);
  readonly itemsCompany = signal<any>([]);

  trackByFn(index, item) {
    return item.id;
  }

  constructor() {
    this.items.set([]);
    this.itemsRoom.set([]);
    this.itemsCompany.set([]);
  }

  ngOnInit() {
    this.items.set(SETTINGS);
  }

  groups(): { name: string; items: any[] }[] {
    const q = this.filter.label.trim().toLowerCase();
    const out: { name: string; items: any[] }[] = [];
    (this.items() as any[])
      .filter((i) => !q || i.label.toLowerCase().includes(q) || (i.description || "").toLowerCase().includes(q))
      .forEach((i) => {
        let g = out.find((x) => x.name === i.group);
        if (!g) out.push((g = { name: i.group, items: [] }));
        g.items.push(i);
      });
    return out;
  }

  reset(): void {
    this.filter.label = "";
  }
}
